function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import * as Surplus from "surplus";
Surplus;
import S from 's-js'; // sanity and safety, we're using POJOs as simple dictionaries.

delete Object.prototype.__proto__;
delete Object.prototype.__defineGetter__;
delete Object.prototype.__definSetter__;
delete Object.prototype.__lookupGetter__;
delete Object.prototype.__lookupSetter__;
S.root(function () {
  var state = {
    filter: S.value(""),
    sortBy: S.value(null)
  };
  var tbody = document.getElementById("missions-table-tbody");
  assert(tbody instanceof HTMLTableSectionElement, "can't find tbody element");
  var columnheadersRow = document.getElementById("missions-table-columnheaders");
  assert(columnheadersRow instanceof HTMLTableRowElement, "can't find thead tr element");
  var filterInput = document.getElementById("missions-table-filter");
  assert(filterInput instanceof HTMLInputElement);

  var handleFilterChange = function handleFilterChange() {
    state.filter(filterInput.value);
  };

  filterInput.addEventListener("input", handleFilterChange);
  var filterInputReset = document.getElementById("missions-table-filter-reset");
  assert(filterInputReset instanceof HTMLButtonElement);
  filterInputReset.addEventListener("click", function () {
    return filterInput.value = "", handleFilterChange();
  });
  S.effect(function () {
    return filterInputReset.style.display = state.filter() !== "" ? "block" : "none";
  }); // Load information about the columns we're using

  var columnMap = {};
  var columns = [];

  function isColumnId(x) {
    return x in columnMap;
  }

  var _iterator = _createForOfIteratorHelper(columnheadersRow.children),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var th = _step.value;
      if (!(th instanceof HTMLTableCellElement)) continue;
      var button = th.querySelector("button");
      if (!(button instanceof HTMLButtonElement)) continue;
      var id = th.id;
      if (!id || id in columnMap) continue;
      var column = {
        id: id,
        th: th,
        button: button
      };
      Object.freeze(column);
      columnMap[id] = column;
      columns.push(column);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  Object.freeze(columnMap);
  Object.freeze(columns); // Load information about each row, so that we can re-sort them later.

  var rows = [];

  var _iterator2 = _createForOfIteratorHelper(tbody.children),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var tr = _step2.value;
      if (!(tr instanceof HTMLTableRowElement)) continue;
      var _columns2 = {};
      var row = {
        tr: tr,
        columns: _columns2
      };

      var _iterator5 = _createForOfIteratorHelper(tr.children),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var td = _step5.value;
          if (!(td instanceof HTMLTableCellElement)) continue;
          if (!isColumnId(td.headers)) continue;
          if (!("value" in td.dataset) || typeof td.dataset.value !== "string") continue;
          var value = JSON.parse(td.dataset.value);
          if (!isSortableValue(value)) continue;
          _columns2[td.headers] = value;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      Object.freeze(row.columns);
      Object.freeze(row);
      rows.push(row);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  Object.freeze(rows); // First we sort all of the rows by whatever the current sorting condition is.

  var sorted = S(function () {
    var sortBy = state.sortBy();
    if (!sortBy) return rows;
    return rows.slice(0).sort(function (a, b) {
      var _a$columns$sortBy$id, _b$columns$sortBy$id;

      return localeCompareSortable((_a$columns$sortBy$id = a.columns[sortBy.id]) !== null && _a$columns$sortBy$id !== void 0 ? _a$columns$sortBy$id : [], (_b$columns$sortBy$id = b.columns[sortBy.id]) !== null && _b$columns$sortBy$id !== void 0 ? _b$columns$sortBy$id : []) * (sortBy.order === "descending" ? -1 : 1);
    });
  });
  var filterRegex = S(function () {
    var exprs = state.filter().trim().split(/\s*[|&,;]+\s*/).filter(function (x) {
      return x.length !== 0;
    });
    if (exprs.length === 0) return null;
    return new RegExp(exprs.map(escapeRegExp).map(function (e) {
      return "(".concat(e, ")");
    }).join('|'), "ig");
  });

  function escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  } // Then we filter out rows that don't match the current filter expression


  var filtered = S(function () {
    var regex = filterRegex();
    if (!regex) return sorted();
    return sorted().filter(function (row) {
      var result = [false];

      var _iterator3 = _createForOfIteratorHelper(columns),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var col = _step3.value;
          mergeMatchResult(result, fuzzyMatchSortable(regex, row.columns[col.id]));
          if (!result.includes(false)) return true;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return false;
    });
  }); // Finally, we use Surplus to replace the tbody content with the current set of filtered rows.

  S.effect(function (__current) {
    if (tbody.parentNode instanceof HTMLElement) {
      var _state$sortBy$id, _state$sortBy;

      tbody.parentNode.dataset.sortedBy = (_state$sortBy$id = (_state$sortBy = state.sortBy()) === null || _state$sortBy === void 0 ? void 0 : _state$sortBy.id) !== null && _state$sortBy$id !== void 0 ? _state$sortBy$id : "";
    }

    return Surplus.content(tbody, filtered().map(function (r) {
      return r.tr;
    }), __current);
  }, Array.from(tbody.childNodes)); // Here we set up transformers for all of the registered regions
  // so that we can highlight portions that are matching the current filter.

  var registeredRegions = tbody.querySelectorAll(".reg");

  var _iterator4 = _createForOfIteratorHelper(registeredRegions),
      _step4;

  try {
    var _loop2 = function _loop2() {
      var _reg$textContent;

      var reg = _step4.value;
      if (!(reg instanceof HTMLSpanElement)) return "continue";
      var text = (_reg$textContent = reg.textContent) !== null && _reg$textContent !== void 0 ? _reg$textContent : "";
      S.effect(function (showing) {
        var regex = filterRegex();

        if (!regex) {
          if (showing) reg.replaceChildren(text);
          return false;
        }

        var content = [];
        var cursor = 0;
        var match = null;

        while ((match = regex.exec(text)) !== null) {
          if (!match[0]) continue;
          if (cursor !== match.index) content.push(text.slice(cursor, match.index));
          content.push(function () {
            var __;

            __ = Surplus.createElement("span", "sel", null);
            Surplus.content(__, match[0], "");
            return __;
          }());
          cursor = match.index + match[0].length;
        }

        if (cursor !== text.length) content.push(text.slice(cursor));
        reg.replaceChildren.apply(reg, content);
        return true;
      }, false);
    };

    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _ret = _loop2();

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  var _loop = function _loop() {
    var col = _columns[_i];
    var sortRules = {
      ascending: {
        id: col.id,
        order: "ascending"
      },
      descending: {
        id: col.id,
        order: "descending"
      },
      none: {
        order: "none"
      }
    };
    var status = S(function () {
      var sortBy = state.sortBy();
      if ((sortBy === null || sortBy === void 0 ? void 0 : sortBy.id) !== col.id) return sortRules.none;
      return sortRules[sortBy.order];
    });
    var order = S(function (prev) {
      var _status = status(),
          order = _status.order;

      col.th.setAttribute("aria-sort", order);
      return order;
    }, col.th.getAttribute("aria-sort"));
    col.button.addEventListener("click", function () {
      var prevOrder = order();
      state.sortBy(prevOrder === "none" ? sortRules.ascending : prevOrder === "ascending" ? sortRules.descending : null);
    });
  };

  for (var _i = 0, _columns = columns; _i < _columns.length; _i++) {
    _loop();
  }
});

function localeCompareSortable(a, b) {
  if (a == null) {
    if (b == null) return 0;
    return -1;
  } else {
    if (b == null) return 1;
  }

  if (typeof a === "string") {
    if (typeof b === "string") return a.localeCompare(b);else return localeCompareSortable(a, b[0]) || 1 - b.length;
  } else {
    if (typeof b === "string") return localeCompareSortable(a[0], b) || a.length - 1;else {
      for (var i = 0; i < a.length && i < b.length; i++) {
        var result = localeCompareSortable(a[i], b[i]);
        if (result !== 0) return result;
      }

      return a.length - b.length;
    }
  }
}

function fuzzyMatchSortable(r, s) {
  if (s == null) {
    return [false];
  } else if (typeof s === "string") {
    var result = [false];
    var match;

    while ((match = r.exec(s)) !== null) {
      mergeMatchResult(result, match);
      if (!result.includes(false)) break;
    }

    r.lastIndex = 0;
    return result;
  } else {
    var _result = [false];

    for (var i = 0; i < s.length; i++) {
      mergeMatchResult(_result, fuzzyMatchSortable(r, s[i]));
      if (!_result.includes(false)) break;
    }

    return _result;
  }
}

function mergeMatchResult(result, match) {
  for (var i = 0; i < match.length; i++) {
    var _i2, _result$_i;

    if (match[i]) result[i] = true;else (_result$_i = result[_i2 = i]) !== null && _result$_i !== void 0 ? _result$_i : result[_i2] = false;
  }

  return result;
}

function isSortableValue(x) {
  if (x == null || typeof x === "string") return true;
  if (!Array.isArray(x)) return false;

  for (var i = 0; i < x.length; i++) {
    if (!isSortableValue(x[i])) return false;
  }

  return true;
}

function assert(x, msg) {
  if (!x) throw new Error(msg);
}